// NATIVE 
import { createRef, Fragment, useRef, useState } from 'react';


// INSTALLED 
import Draggable from 'react-draggable';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import { PaperProps } from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Chip, CircularProgress } from '@mui/material';
import {
  Accordion, AccordionSummary, AccordionDetails, Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


// CUSTOM 
import { useSelector } from 'react-redux';
import { formatDateToYmd } from '../../../commons/utils';


// fuera del componente para mantener la referencia viva
const draggableRef:any = createRef<HTMLDivElement>();

const PaperComponent = (props: PaperProps) => {
  return (
    <Draggable
      nodeRef={draggableRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={draggableRef} {...props} />
    </Draggable>
  );
};




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


 
export const TareasPendientes = (props:any) =>  {


  const { employeesTareasPendientes } = useSelector( (state: any) => state.employee );

  // PROPS 
  const{ open, handleCloseModal } = props;


  const [expanded, setExpanded] = useState<string | false>(false);
  const [loadingId, setLoadingId] = useState<string | null>(null);

  const handleChange = (panelId: string) => async () => {
    if (expanded === panelId) {
      setExpanded(false);
    } else {
      setLoadingId(panelId);
      await new Promise((res) => setTimeout(res, 500)); // Simula carga de datos
      setExpanded(panelId);
      setLoadingId(null);
    }
  };

   
  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModal(false);
  };


  



  return (
    <Fragment>

      
      <Dialog
        onClose={handleClose}
        open={open}
        fullWidth={true}
        maxWidth={'md'}
        PaperComponent={PaperComponent}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title" sx={{ m: 0, p: 2, background: '#FF7374', color: '#fff', display: 'flex', alignItems: 'center', gap: 1 }} >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <svg width="30" height="30" fill="none" viewBox="0 0 24 24" style={{ marginRight: 8 }}>
              <circle cx="12" cy="12" r="12" fill="#fff" opacity="0.15"/>
              <path d="M12 12c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="#fff"/>
              <path d="M17.5 10.5l-2.5 2.5-1-1 1.5-1.5 1 1 2-2 1 1-2.5 2.5z" fill="#43a047"/>
            </svg>
          </span>
          Empleados tareas pendientes
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#fff',
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
          <Grid container spacing={2}>
            {employeesTareasPendientes.map((empleado: any) => {
              const isExpanded = expanded === empleado.id;
              const isLoading = loadingId === empleado.id;

              return (
                <Grid size={12} key={empleado.id}>
                  <Accordion expanded={isExpanded} onChange={handleChange(empleado.id)}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      id={`panel-${empleado.id}`}
                      sx={{
                        backgroundColor: '#f4f6f8',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <Typography sx={{ fontWeight: 600 }}>
                          {empleado.nombre}
                        </Typography>

                        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                          {isLoading ? (
                            <CircularProgress size={30}  />
                          ) : (
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 500, color: '#1976d2', cursor: 'pointer' }}
                              onClick={handleChange(empleado.id)}
                            >
                              {isExpanded ? 'Ver menos' : 'Ver más'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </AccordionSummary>

                    <AccordionDetails>
                      <TableContainer component={Paper} elevation={3}>
                        <Table>
                          <TableHead sx={{ backgroundColor: '#e3e7eb' }}>
                            <TableRow>
                              <TableCell>#</TableCell>
                              <TableCell>Tarea pendiente</TableCell>
                              <TableCell>Días atrasada</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {empleado.faltantes.map((item: any, idx: number) => (
                              <TableRow key={idx}>
                                <TableCell>{idx + 1}</TableCell>
                                <TableCell>{item.campo.replace(/_/g, ' ')}</TableCell>
                                <TableCell>
                                  <Chip
                                    label={`${item.dias} días`}
                                    sx={{ fontWeight: 'bold', borderColor: '#FF7374', color: '#FF7374' }}
                                    variant="outlined"
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              );
            })}
          </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}